import { ArrowRightSmall } from '@zoopla-eng/zds-components/icons';
import { Link } from '@zoopla-eng/zds-components/link';
import { Stack } from '@zoopla-eng/zds-components/stack';
import { styled } from '@zoopla-eng/zds-components/themes';
import { NewHomesPageSubtitleShort } from '../NewHomesPageSubtitleShort';
import {
    trackHelpToBuy,
    trackNewBuildDevelopments,
    trackRetirement,
    trackSharedOwnership
} from './NewHomesSubNav.tracking';

const List = styled('ul', {
    listStyleType: 'none',
    display: 'flex',
    flexDirection: 'column',
    rowGap: '$S500',
    '@M100': {
        flexDirection: 'row',
        flexWrap: 'wrap'
    }
});
List.displayName = 'List';

const ListItem = styled('li', {
    display: 'flex',
    alignItems: 'center',
    columnGap: '$S300',
    '@M100': {
        flexBasis: '50%'
    }
});
ListItem.displayName = 'ListItem';

export const NewHomesSubNav = () => {
    return (
        <Stack rowGap="$S500">
            <NewHomesPageSubtitleShort>
                Explore more new-build properties, including:
            </NewHomesPageSubtitleShort>
            <List>
                <ListItem>
                    <ArrowRightSmall />
                    <Link
                        href="/new-homes/developers/"
                        onClick={trackNewBuildDevelopments}
                    >
                        UK new-build developments
                    </Link>
                </ListItem>
                <ListItem>
                    <ArrowRightSmall />
                    <Link href="/schemes/help-to-buy/" onClick={trackHelpToBuy}>
                        Help to Buy
                    </Link>
                </ListItem>
                <ListItem>
                    <ArrowRightSmall />
                    <Link
                        href="/schemes/shared-ownership/"
                        onClick={trackSharedOwnership}
                    >
                        Shared Ownership
                    </Link>
                </ListItem>
                <ListItem>
                    <ArrowRightSmall />
                    <Link href="/retirement/" onClick={trackRetirement}>
                        Retirement
                    </Link>
                </ListItem>
            </List>
        </Stack>
    );
};
